import React from 'react'
import * as Displays from '@morningtrain/react-displays'
import Fieldset from '../../../layouts/form/Fieldset'
import * as Fields from 'support/fields'
import * as Filters from 'support/filters'
import Button from '../../../ui/buttons/Button'
import { Translation } from '@morningtrain/react-translations'
import { Pipeline } from '@morningtrain/react-helpers'
import { ExecuteOperationOnPipe, TriggerPipelineOnFormSubmit, useValue } from '@morningtrain/react-resources'
import DeleteModelOnClick from 'support/actions/generic/DeleteModelOnClick'
import * as UI from 'ui'
import { ResetSmartviewOnPipe } from '@morningtrain/react-smartviews'
import {Env} from "@morningtrain/helpers";

export default function ShiftSmartviewEditForm ({ slotId }) {
  const format = 'YYYY-MM-DD HH:mm:ss'
  const scheduleId = useValue('schedule_id')
  const hasClosingType = Env.get('globals.has_closing_type');
  return (
    <>
      <Fieldset cols={1}>
        <Fields.Hidden name='schedule_id' />
        <Fields.Hidden name='day' />
        <Fieldset cols={2}>
          <Fields.Time fromName='start_at' name='start_time' label='Fra' parseFormat={format} />
          <Fields.Time fromName='end_at' name='end_time' label='Til' parseFormat={format} />
        </Fieldset>
        {
          hasClosingType === 1 ?
          <Fields.Select
            name='closing_type' enum='closing_type' placeholder='Ingen'
            label='Lukketype'
          /> : false
        }
        <Fields.Input name='note' label={<Translation name='fields.shift_comment.label' />} />
        <Fields.AvailableScheduleUsers>
          <Filters.ModelValueFilter name='date' modelKey='start_at' />
          <Filters.ModelValueFilter name='schedule' modelKey='schedule_id' />
        </Fields.AvailableScheduleUsers>
        <UI.ButtonWrap className='my-4 mx-3'>
          <UI.Button type='submit'>
            <Translation name='actions.save_shift' />
          </UI.Button>
          <DeleteModelOnClick pipes={(
            <>
              <ExecuteOperationOnPipe
                resourceName='shifts.schedule_slot'
                operationName='grouped_by_day'
              />
              <ExecuteOperationOnPipe
                resourceName='shifts.schedule'
                operationName='summary'
                data={{ schedule: scheduleId }}
              />
              <ResetSmartviewOnPipe />
            </>
            )}
          >
            <UI.DeleteButton big />
          </DeleteModelOnClick>
        </UI.ButtonWrap>

        <Pipeline>
          <TriggerPipelineOnFormSubmit />
          <ExecuteOperationOnPipe
            resourceName='shifts.schedule_slot'
            operationName='grouped_by_day'
          />
          <ExecuteOperationOnPipe
            resourceName='shifts.schedule'
            operationName='summary'
            data={payload => {
              return { schedule: payload.data.model.schedule_id }
            }}
          />
        </Pipeline>
      </Fieldset>
    </>
  )
}
